import { render, staticRenderFns } from "./douyin_ewm.vue?vue&type=template&id=2141a4c5&scoped=true"
import script from "./douyin_ewm.vue?vue&type=script&lang=js"
export * from "./douyin_ewm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2141a4c5",
  null
  
)

export default component.exports